module.exports = __webpack_public_path__ + "static/media/blank.c413b4cb.jpg";